export function sanitizeLegacyHtml(value: string): string {
  return value
    .replace(/<\/?(script|style)[^>]*>/gi, '')
    .replace(/ on[a-z]+="[^"]*"/gi, '')
    .replace(/ on[a-z]+='[^']*'/gi, '')
    .replace(/javascript:/gi, '')
}

export function decodeHtmlEntities(value: string): string {
  if (typeof document === 'undefined') return value
  const textarea = document.createElement('textarea')
  textarea.innerHTML = value
  return textarea.value
}

export function legacyHtmlText(value: string): string {
  const withoutTags = value.replace(/<[^>]*>/g, ' ')
  return decodeHtmlEntities(withoutTags).replace(/\s+/g, ' ').trim()
}
